/** @flow */
import type { StoreResourceDef } from 'app/core/types'

export const jobSkillLevels: StoreResourceDef<> = {
  resourceType: 'jobSkillLevels',
}
